<div
  *ngIf="state.columnDataType"
  class="column-type-box"
  [matTooltip]="state.columnDataType.name || ''"
  [ngStyle]="{ 'background-color': state.columnDataType.color }"
>
  <img
    [src]="state.columnDataType.icon"
    [width]="state.columnDataType.columnType === ColumnTypeEnum.Float ? 12 : 9"
    alt=""
  />
</div>
